"use client";

import GoogleJavaScriptMap from "@/components/ui/GoogleJavaScriptMap";
import React, { useMemo } from "react";
import type { ContactInfo } from "@/lib/server/contact";

interface ContactGoogleMapProps {
    /** Layout ile gelen iletişim bilgisi; harita lat/lng buradan alınır */
    contactInfo?: ContactInfo | null;
}

export default function ContactGoogleMap({ contactInfo }: ContactGoogleMapProps) {
    const mapData = useMemo(() => {
        if (contactInfo && contactInfo.lat != null && contactInfo.lng != null) {
            return {
                lat: contactInfo.lat,
                lng: contactInfo.lng,
                title: contactInfo.companyName || "",
                address: contactInfo.address || "",
            };
        }
        return null;
    }, [contactInfo]);

    if (!mapData) {
        return null;
    }

    return (
        <section className="w-full">
            <GoogleJavaScriptMap
                className="w-full h-[400px] lg:h-[500px]"
                mapData={mapData}
            />
        </section>
    );
}
